import React, {useEffect, useState} from 'react';
import style from './style.scss'
import newId from '../../utils/newid';
import Label from './Label';


const Textarea = (props) => {
    const {item, field, validateField} = props;
    const id = newId();
    const [error, setError] = useState(false);
    const [value, setValue] = useState((typeof field !== "undefined") && field[item.item]);
    let timer = false;

    return (
        <div className={style.typeTextarea}>
            {
                (typeof item.label !== 'undefined') &&
                <Label
                    id={id}
                    parentClass
                    label={item.label}
                />}
            {error && 'error'}
            <textarea
                id={id}
                className={style.input + " " + error && style.hasError}
                onChange={(t) => {
                    setValue(t.target.value);
                    return props.handleChange(t.target.value)

                }}>{value}</textarea>
            {item.label && item.label.second && <span className={style.secondLabel}>{item.label.second}</span>}
            {error && <span className={style.errorMessage}>{error.message}</span>}
        </div>
    )
}

export default Textarea;
